var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 7.33333C6.4165 4.80203 8.46854 2.75 10.9998 2.75C13.5311 2.75 15.5832 4.80203 15.5832 7.33333V10.0833C15.5832 12.6146 13.5311 14.6667 10.9998 14.6667C8.46854 14.6667 6.4165 12.6146 6.4165 10.0833V7.33333Z",
    stroke: "white",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 7.33337H15.5832",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 10.0834H15.5832",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.16663V10.0833C18.3332 14.1334 15.0499 17.4166 10.9998 17.4166C6.94975 17.4166 3.6665 14.1334 3.6665 10.0833V9.16663",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4166V20.1666",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophone);
export default __webpack_public_path__ + "static/media/icon-microphone.a3bcc1c8753cd905e72a792dc0fbb427.svg";
export { ForwardRef as ReactComponent };